import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { TableRowProps } from '@mui/material/TableRow'
import { CompetitionEntryDocument } from '@rallycry/api-suite-typescript/dist/models/CompetitionEntryDocument'
import { Issue } from '@rallycry/api-suite-typescript/dist/models/Issue'
import {
  RcTableBodyRow,
  RcTableCell,
  RcTableStickyBodyCell
} from '../../../../molecules/text/RcTable'
import { TeamCountDisplay } from './TeamCountDisplay'
import { TeamIssueTooltip } from './TeamIssueTooltip'
import { RcIconButton } from '@/components/molecules/interactive/RcIconButton'
import { TeamAvatar } from '@/components/organisms/avatar/TeamAvatar'
import { useIsMobile } from '@/core/hooks/useMediaQueries'
import { useNavigation } from '@/core/hooks/useNavigation'
import { CompetitionRoute, RootRoute } from '@/core/route-keys'
import { useCompetition } from '@/entity/competition/useCompetition'
import { useOrganizationCommunity } from '@/entity/organization/useOrganizationCommunity'

export interface TeamsTableRowProps extends TableRowProps {
  team: CompetitionEntryDocument
  rank?: number
  issues?: Issue[]
}

export const TeamsTableRow = ({
  team,
  rank,
  issues,
  ...rest
}: TeamsTableRowProps) => {
  const { getPath, navTo } = useNavigation()
  const { competition, settings, isCompetitionModerator, isSoloCompetition } =
    useCompetition()
  const community = useOrganizationCommunity({ community: team.representing })
  const isMobile = useIsMobile()

  const teamPath = getPath({
    root: RootRoute.Competition,
    rootId: competition?.id,
    subRoute: CompetitionRoute.Team,
    subId: team?.id
  })

  return (
    <RcTableBodyRow {...rest} onClick={() => navTo(teamPath)}>
      <RcTableStickyBodyCell>
        <Box pl={5}>
          <TeamAvatar
            team={team}
            community={community}
            rank={rank}
            showLfm
            showMemberCount={isMobile}
          />
        </Box>
      </RcTableStickyBodyCell>
      <RcTableCell>{team.seed}</RcTableCell>
      {isSoloCompetition ? null : (
        <RcTableCell>
          <Stack
            direction='row'
            alignItems='center'
            spacing={2}
            color='text.secondary'
          >
            <TeamCountDisplay
              current={team.playersCount}
              min={settings?.teamSizeMin}
              max={settings?.teamSizeMax}
            />
          </Stack>
        </RcTableCell>
      )}

      <RcTableCell align='right' sx={{ justifyContent: 'flex-end' }}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='flex-end'
          spacing={2}
        >
          {isCompetitionModerator ? (
            <TeamIssueTooltip teamId={team.id!} />
          ) : null}
          <RcIconButton icon={['fal', 'chevron-right']} size='small' />
        </Stack>
      </RcTableCell>
    </RcTableBodyRow>
  )
}
